import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
// import { StateService } from '@uirouter/angular';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { AppinfoService } from './../../../services/appinfo.service';
import { CommonFunctionService } from './../../../services/common-function.service';
import { ContentJobsService, Layer } from './../content-jobs.service';
import { LayerCategory, FieldMappingService } from './../../../services/field-mapping.service';
import { CommonTableService } from 'app/services/common-table.service';
import { LayerService, LayerMaintainType, LayerLoadState } from 'app/services/layer.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ConfirmModalComponent, ConfirmModalData } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { MatDialogConfig } from '@angular/material';
import { UserService } from 'app/services/user.service';
import { EditService } from 'app/services/edit.service';

export interface LayerCategoryExt extends LayerCategory {
	hasSubmitted: boolean;
	hasApproved: boolean;
	prevMappedLayerName?: string;
	layerState: LayerLoadState;
	layerMaintainType: LayerMaintainType;
}

@Component({
	selector: 'app-jobs-add-files',
	templateUrl: './jobs-add-files.component.html',
	styleUrls: ['./jobs-add-files.component.css']
})
export class JobsAddFilesComponent implements OnInit, OnDestroy {

	@ViewChild('fileForm', { static: false }) fileForm: NgForm;
	//
	public layers: Observable<Layer[]>;
	// Selected layer
	public selectedLayer: Layer;

	public categoryList: LayerCategoryExt[];
	// Preview
	public previewRows: any[] = [];
	public previewColumns: any[] = [];

	private selectedCusSub: Subscription;
	constructor(
		private router: Router,
		private toastr: ToastrService,
		private appinfoService: AppinfoService,
		private commonFuncService: CommonFunctionService,
		private editService: EditService,
		private modalService: CommonModalService,
		private tableService: CommonTableService,
		private jobsService: ContentJobsService,
		private fieldMappingService: FieldMappingService,
		private layerService: LayerService,
		private userService: UserService
	) { }

	async loadFiles(files: FileList) {
		this.commonFuncService.setLoadingSpinner(true);
		try {
			const rsp = await this.jobsService.transformLoadedFiles(files);
			this.handleLoadFiles(rsp);
		} catch (err) {
			this.handleLoadFilesError();
			this.toastr.error(err.message);
		}
		this.commonFuncService.setLoadingSpinner(false);
	}
	// This func is for both loadFiles and onDropFiles
	private handleLoadFiles(data) {
		const promises = []; // Promises for selecting layers
		if (data.fgdbZip) {
			for (const fgdb of Object.keys(data.fgdbZip)) {
				const promiseFgdbZip = new Promise<void>((resolveFgdbZip, rejectFgdbZip) => {
					this.jobsService.openLayerSelectWindow({
						fgdb: fgdb,
						layers: Object.keys(data.fgdbZip[fgdb].layers)
					}, (layers) => {
						// Cancel
						layers = layers || [];
						const layersUpdated = this.jobsService.layers.getValue();
						// Upload selected layers
						for (const l of Object.keys(data.fgdbZip[fgdb].layers)) {
							const existedLayer = layersUpdated.find((layer) => {
								return layer.name === l && layer.fileName === fgdb && layer.type === 'fgdbZip';
							});
							if (!existedLayer) {
								if (layers.indexOf(l) !== -1) {
									// data.fgdbZip[fgdb].layers[l].selected = true;
									const content = data.fgdbZip[fgdb].layers[l];
									const cateGeomType = this.getLayerCateGeomType(content.type);
									const cate = this.setInitLayerCate(l, cateGeomType);
									const layer = {
										name: l,
										type: 'fgdbZip',
										fileName: fgdb,
										maintainType: cate.maintainType,
										category: cate.cateName,
										content: content,
										cateGeomType: cateGeomType
									};
									this.addGeneralColType(layer)
									layersUpdated.push(layer);
								} else {
									// data.fgdbZip[fgdb].layers[l].selected = false;
									delete data.fgdbZip[fgdb].layers[l];
								}
							}
						}
						this.jobsService.layers.next(layersUpdated);
						resolveFgdbZip();
					});
				});
				promises.push(promiseFgdbZip);
			}
		}
		const layersUpdated = this.jobsService.layers.getValue();
		if (data.shp) {
			for (const shp of Object.keys(data.shp)) {
				const existedLayer = layersUpdated.find((layer) => {
					return layer.name === shp && layer.type === 'shp';
				});
				if (!existedLayer) {
					const content = data.shp[shp].info;
					const cateGeomType = this.getLayerCateGeomType(content.type);
					const cate = this.setInitLayerCate(shp, cateGeomType);
					const layer = {
						name: shp,
						type: 'shp',
						fileName: shp,
						content: content,
						cateGeomType: cateGeomType,
						category: cate.cateName,
						maintainType: cate.maintainType
					};
					this.addGeneralColType(layer);
					layersUpdated.push(layer);
				}
			}
		}
		if (data.shpZip) {
			for (const zip of Object.keys(data.shpZip)) {
				for (const layer of Object.keys(data.shpZip[zip].layers)) {
					const existedLayer = layersUpdated.find((l) => {
						return l.name === layer && l.type === 'shpZip';
					});
					if (!existedLayer) {
						const content = data.shpZip[zip].layers[layer].info;
						const cateGeomType = this.getLayerCateGeomType(content.type);
						const cate = this.setInitLayerCate(layer, cateGeomType);
						const l = {
							name: layer,
							type: 'shpZip',
							fileName: zip,
							content: content,
							cateGeomType: cateGeomType,
							category: cate.cateName,
							maintainType: cate.maintainType
						};
						this.addGeneralColType(l);
						layersUpdated.push(l);
					}
				}
			}
		}
		if (data.fgdb) {
			for (const name of Object.keys(data.fgdb)) {
				const promiseFgdb = new Promise<void>((resolveFgdb, rejectFgdb) => {
					this.jobsService.openLayerSelectWindow({
						fgdb: name,
						layers: Object.keys(data.fgdb[name].layers)
					}, (layers) => {
						// Cancel
						// if (!layers) {
						// 	delete data.fgdb[name];
						// 	resolveFgdb();
						// 	return;
						// }
						layers = layers || [];
						const layersUpdatedFgdb = this.jobsService.layers.getValue();
						// Upload selected layers
						for (const l of Object.keys(data.fgdb[name].layers)) {
							const existedLayer = layersUpdatedFgdb.find((layer) => {
								return layer.name === l && layer.fileName === name && layer.type === 'fgdb';
							});
							if (!existedLayer) {
								if (layers.indexOf(l) !== -1) {
									// data.fgdb[name].layers[l].selected = true;
									const content = data.fgdb[name].layers[l];
									const cateGeomType = this.getLayerCateGeomType(content.type);
									const cate = this.setInitLayerCate(l, cateGeomType);
									const layer = {
										name: l,
										type: 'fgdb',
										fileName: name,
										category: cate.cateName,
										maintainType: cate.maintainType,
										content: content,
										cateGeomType: cateGeomType
									};
									this.addGeneralColType(layer);
									layersUpdatedFgdb.push(layer);
								} else {
									// data.fgdb[name].layers[l].selected = false;
									delete data.fgdb[name].layers[l];
								}
							}
						}
						this.jobsService.layers.next(layersUpdatedFgdb);
						resolveFgdb();
					});
				});
				promises.push(promiseFgdb);
			}
		}
		this.jobsService.layers.next(layersUpdated);
		Promise.all(promises)
		.catch()
		.then(() => {
			this.jobsService.addRawFiles(data);
			this.clickLayer(0);
		});
	}
	private handleLoadFilesError() {
		this.toastr.error('Uploading failed.');
	}
	// Given loaed layer's geom type, get the available geomType of category
	private getLayerCateGeomType(layerGeomType: string): 'POINT' | 'LINE' | 'AREA' {
		// switch (layerGeomType) {
		// 	case 'Point': return 'POINT';
		// 	case 'PolyLine': return 'LINE';
		// 	case 'Polygon': return 'AREA';
		// }
		// For cases like PolyLineZ:
		if (layerGeomType) {
			if (layerGeomType.toLowerCase().includes('point')) {
				return 'POINT';
			} else if (layerGeomType.toLowerCase().includes('polyline')) {
				return 'LINE';
			} else if (layerGeomType.toLowerCase().includes('polygon')) {
				return 'AREA';
			}
		}
	}
	// Convert field types to general
	private addGeneralColType(layer: Layer) {
		if (layer.content.fields) {
			layer.content.fields.forEach((f) => {
				f.generalColType = this.appinfoService.findGeneralCol(f.LBType);
			});
		}
	}



	async onDropFiles(data: {items: DataTransferItemList}) {
		if (data.items) {
			this.commonFuncService.setLoadingSpinner(true);
			try {
				const rsp = await this.jobsService.transformDroppedFiles(data.items);
				this.handleLoadFiles(rsp);
			} catch (err) {
				console.log(err);
				this.handleLoadFilesError();
				this.toastr.error(err.message);
			}
			this.commonFuncService.setLoadingSpinner(false);
		}
	}

	clickLayer(idx) {
		const layers = this.jobsService.layers.getValue();
		this.selectedLayer = layers[idx];
		if (this.selectedLayer && this.selectedLayer.content && this.selectedLayer.content.rows) {
			this.previewRows = this.selectedLayer.content.rows;
			if (!this.previewRows[0]) {
				this.previewColumns = [];
			} else {
				// const cols = [];
				// Object.keys(this.previewRows[0]).forEach((col) => {
				// 	cols.push({
				// 		name: col,
				// 		prop: col
				// 	});
				// });
				// this.previewColumns = cols;
				this.previewColumns = this.tableService.setColumnsFromRows(this.previewRows);
			}
		} else {
			this.previewRows = [];
			this.previewColumns = [];
		}
	}
	removeLayer(idx) {
		const layers = this.jobsService.layers.getValue();
		const layer = layers[idx];
		// Remove preview if selected
		if (layer === this.selectedLayer) {
			this.previewColumns = [];
			this.previewRows = [];
		}
		this.jobsService.removeRawFilesByLayer(layer);
		layers.splice(idx, 1);
		this.jobsService.layers.next(layers);
		// setTimeout(() => {
		// 	this.fileForm.form.updateValueAndValidity();
		// });
	}
	async changeCate(layerIdx: number, cate: string) {
		const layers = this.jobsService.layers.getValue();
		const layer = layers[layerIdx];
		const category = this.categoryList.find((c) => c.name === cate);
		layer.maintainType = category.layerMaintainType;
		const clearLayerCate = (l: Layer) => {
			l.category = null
			l.maintainType = null;
		};
		// Check if the selected category has submitted-layer or not
		if (category.hasSubmitted || category.hasApproved) {
			setTimeout(() => clearLayerCate(layer));
			this.toastr.warning(category.name + ' layer is already submitted.')
			return;
		}
		//
		this.commonFuncService.setLoadingSpinner(true);
		try {
			// Check the last loaded file name of the selected category
			if (category.hasSubmitted||category.hasApproved) {

			}
			// const rsp = await this.fieldMappingService.getSchemaMapping(category.id);
			const prevLoadedLayerName = category.prevMappedLayerName;
			if (prevLoadedLayerName) {
				if (prevLoadedLayerName !== layers[layerIdx].name) {
					const options: MatDialogConfig = {
						height: '250px',
						width: '520px'
					};
					const data: ConfirmModalData = {
						title: 'Warning!',
						message: 'The incoming layer name ' + layers[layerIdx].name +
							' is different from that of the existing layer ' + prevLoadedLayerName + '.'
							+ '\n\n Are you sure to proceed?',
						yesBtnText: 'Ok',
						noBtnText: 'Cancel'
					}
					options.data = data;
					const result = await this.modalService.openModalWindow(ConfirmModalComponent, options);
					if (!result) {
						clearLayerCate(layer);
						this.commonFuncService.setLoadingSpinner(false);
						return;
					}
				}
			}
		} catch (err) {}
		this.commonFuncService.setLoadingSpinner(false);
		const layerWithSameCate = layers.find((l, idx) => {
			return l.category === cate && idx !== layerIdx;
		});
		if (layerWithSameCate) {
			clearLayerCate(layerWithSameCate);
		}
		this.jobsService.layers.next(layers);
	}
	private async updateCatePrevLayer() {
		// Get previous mapped layers
		const prevMapping = await this.fieldMappingService.getPrevMapping();
		this.categoryList.forEach((c) => {
			const prev = prevMapping.find((m) => c.id === m.cateId);
			if (prev) {
				c.prevMappedLayerName = prev.prevLayerName;
			} else {
				c.prevMappedLayerName = null;
			}
		});
	}
	private setInitLayerCate(layerName: string, cateGeomType) {
		let category = this.categoryList.find((c) => c.prevMappedLayerName === layerName && c.geomType === cateGeomType);
		if (!category) {
			// Check geomType, match POINT -> address, LINE -> centerline
			// Because there's only one layer category with LINE/POINT
			const currLayers = this.jobsService.layers.getValue();
			if (cateGeomType === 'LINE' || cateGeomType === 'POINT') {
				const layerWithSameGeomType = currLayers.find((l) => l.cateGeomType === cateGeomType);
				if (!layerWithSameGeomType) {
					category = this.categoryList.find((c) => c.geomType === cateGeomType);
				}
			}
		}
		let cateName: string, maintainType: LayerMaintainType;
		if (category && !category.hasSubmitted && !category.hasApproved) {
			cateName = category.name;
			maintainType = category.layerMaintainType;
		}
		return {
			cateName: cateName,
			maintainType: maintainType
		};
	}
	// Allow overriding previously loaded layer or not for enterprised user
	private async checkPrevLoadedLayer() {
		if (this.userService.userSubscription.subLevel !== this.editService.editRequiredSubLevel) {
			return true;
		}
		// For enterprise users:
		const layers = this.jobsService.layers.getValue();
		const prevLoadedLayers = layers.filter(l => {
			const cate = this.categoryList.find(c => c.name === l.category);
			if (cate && cate.layerState.num >= 1) {
				return true;
			}
		});
		if (prevLoadedLayers.length > 0) {
			const options: MatDialogConfig = {
				height: '250px',
				width: '520px'
			};
			const data: ConfirmModalData = {
				title: 'Warning!',
				message: 'This upload will result in over-writing the following layers: ' + prevLoadedLayers.map(l => l.category).join(',') + '. '
					+ '\n\n OK to continue?',
				yesBtnText: 'Ok',
				noBtnText: 'Cancel'
			}
			options.data = data;
			return await this.modalService.openModalWindow(ConfirmModalComponent, options);
		} else {
			return true;
		}
	}
	async goNext() {
		const rsp = await this.checkPrevLoadedLayer();
		if (!rsp) {
			return;
		}
		// this.stateService.go('jobsfieldmapping');
		this.router.navigate(['azgiv/jobs/field-mapping']);
	}
	trackByFn(idx) {
		return idx;
	}
	async ngOnInit() {
		// On Wizard Mode
		this.jobsService.wizard = 'on';
		//
		this.layers = this.jobsService.layers.asObservable();
		// Loadable layers
		const userSubId = this.userService.getUserInfo().userSubId;
		const loadableList = await this.layerService.getLoadableLayerTypeList(userSubId);
		// Update category's hasSubmitted value
		const list: LayerCategoryExt[] = [];
		this.appinfoService.layerTypeList.forEach(t => {
			const loadableLayer = loadableList.find(i => t.code === i.code);
			if (!loadableLayer || !loadableLayer.loadable) {
				return;
			}
			const layer = this.layerService.layerListBS.getValue().layers.find((l) => l.category.code === t.code);
			
			let hasSubmitted = false;
			let hasApproved = false;
			if (layer) {
				if (layer.state.name === 'SUBMIT') {
					hasSubmitted = true
				} else if (layer.state.name === 'APPROVE') {
					hasApproved = true;
				}
			}
			const layerCate: LayerCategoryExt =  Object.assign({
				hasSubmitted: hasSubmitted,
				hasApproved: hasApproved,
				layerState: layer ? layer.state : null,
				layerMaintainType: loadableLayer.maintainType
			}, t);
			list.push(layerCate);
		})
		this.categoryList = list;
		// this.categoryList = this.appinfoService.layerTypeList.map((t) => {
		// 	const layer = this.layerService.layerList.find((l) => l.category.code === t.code);
		// 	let hasSubmitted = false;
		// 	let hasApproved = false;
		// 	if (layer) {
		// 		if (layer.state === 3) {
		// 			hasSubmitted = true
		// 		} else if (layer.state === 5) {
		// 			hasApproved = true;
		// 		}
		// 	}
		// 	return Object.assign({
		// 		hasSubmitted: hasSubmitted,
		// 		hasApproved: hasApproved,
		// 		layerState: layer ? layer.state : null
		// 	}, t);
		// });
		this.selectedCusSub = this.userService.selectedCustomer.subscribe((cus) => {
			if (cus) {
				this.updateCatePrevLayer();
			}
		});
		const layers = this.jobsService.layers.getValue();
		this.selectedLayer = layers[0];
	}
	ngOnDestroy() {
		this.selectedCusSub.unsubscribe();
	}
}
